import { useApi } from '@classgo/app-kit';
import type { FamilyStudent } from '@classgo/shared';
import { Card } from '@classgo/ui';
import { useQuery } from '@tanstack/react-query';

import { useT } from '../../i18n';

/**
 * What a guardian sees first: their children and where each is this year (ticket #63). The
 * API answers only the caller's own children.
 */
export const FamilyCard = () => {
  const t = useT();
  const api = useApi();
  const family = useQuery({
    queryKey: ['me', 'students'],
    queryFn: () => api.request<{ items: FamilyStudent[] }>('/me/students'),
  });
  return (
    <Card title={t('home.family.title')}>
      {family.data ? (
        family.data.items.length === 0 ? (
          <p className="text-sm text-gray-500">{t('home.family.empty')}</p>
        ) : (
          <ul className="divide-y divide-gray-100">
            {family.data.items.map((student) => (
              <li key={student.id} className="flex items-start justify-between gap-4 py-3">
                <div>
                  <p className="font-medium text-gray-900">
                    {student.givenName} {student.familyName}
                  </p>
                  <p className="text-sm text-gray-500">
                    {student.enrollment
                      ? `${student.enrollment.grade} · ${student.enrollment.group} · ${student.enrollment.sede}`
                      : t('home.family.notEnrolled')}
                  </p>
                </div>
                <span className="text-xs text-gray-500">{student.relationship}</span>
              </li>
            ))}
          </ul>
        )
      ) : (
        <p className="text-sm text-gray-500">{t('common.loading')}</p>
      )}
    </Card>
  );
};
